import {
  Component,
  ChangeDetectionStrategy,
  ElementRef,
  Input,
} from '@angular/core';
import {
  EditorNode,
  EditorNodeComponent,
  NodeAttribute,
} from '@principle-theorem/ng-prosemirror';
import { NodeGroup, BlockNodes } from '@principle-theorem/editor';
import { ReplaySubject } from 'rxjs';

@EditorNode({
  name: BlockNodes.VideoUploading,
  group: NodeGroup.Block,
  inline: false,
  selectable: false,
})
@Component({
    selector: 'pt-video-uploading',
    templateUrl: './video-uploading.component.html',
    styleUrls: ['./video-uploading.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class VideoUploadingComponent extends EditorNodeComponent {
  progress$ = new ReplaySubject<number>(1);

  @NodeAttribute()
  @Input()
  set progress(progress: number) {
    this.progress$.next(progress);
  }

  constructor(elementRef: ElementRef) {
    super(elementRef);
  }
}
